import axios from "axios";
import { gettoken } from "../token/token";
import apiurl from "../apiendpoint/apiendpoint";

export const apigetCurrentaffairById = async (id) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/currentaffairs/apigetcurrentaffairbyid/${id}`, {headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const getAdjacentCurrentAffairs = async (id) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/currentaffairs/api-get-adjacent-posts/${id}`, {headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const apigetHeaderEnabledAffairs = async (params) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/currentaffairs/apigetallHeaderCA`,{params:params,headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apigetDownloadEnabledAffairs = async (params) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/currentaffairs/apigetallDownloadsCA`,{params:params,headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apigetMonthlyData = async (params) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/currentaffairs/apigetmonthlyData`,{params:params,headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

// services/apiCurrentAffairs/apicurrentaffairs.js

export const apigetMonthlyDataDetails = async (monthYearString) => {
    try {
        const token = gettoken();
        
        // Split "November 2025" → { month: "November", year: 2025 }
        const [month, yearStr] = monthYearString.trim().split(" ");
        const year = parseInt(yearStr);

        if (!month || isNaN(year)) {
            throw new Error("Invalid month/year format");
        }

        const res = await axios.get(`${apiurl()}/currentaffairs/apigetmonthlyDataDetail`, {
            params: { month, year },  // This is correct
            headers: { "Authorization": `Bearer ${token}` }
        });
        
        return res.data;
    } catch (err) {
        console.error("Error fetching monthly details:", err.response?.data || err.message);
        throw err;
    }
};